import { Route, Switch } from 'react-router';

import EditGoal from './EditGoal';
import Goal from './Goal';
import UserGoals from './UserGoals';
import ViewerGoals from './ViewerGoals';
import OrganizationGoals from './OrganizationGoals';
import GoalRevision from './GoalRevision';
import CollectiveGoals from './collective-goals/CollectiveGoals';

export default function Goals() {
	return (
		<Switch>
			<Route path={[`/v2/goals`, `/v2/goals/competencies`]} exact>
				{({ match }) => match && <ViewerGoals />}
			</Route>
			<Route path="/v2/goals/organization" exact>
				{({ match }) => match && <OrganizationGoals />}
			</Route>
			<Route path="/v2/goals/collective" exact>
				{({ match }) => match && <CollectiveGoals />}
			</Route>
			<Route path="/v2/goals/collective/:id" exact>
				{({ match }) => match && <CollectiveGoals />}
			</Route>
			<Route path={['/v2/users/:id/goals', '/users/:id/goals']} exact>
				{({ match }) => match && <UserGoals userID={match.params.id} />}
			</Route>
			<Route
				path={[
					`/v2/goals/new`,
					`/v2/users/:id/goals/new`,
					`/v2/goals/:goalID/edit`,
					`/v2/users/:id/goals/:goalID/edit`,
				]}
				exact
			>
				{({ match }) =>
					match && (
						<EditGoal
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={'goalID' in match.params ? match.params.goalID : undefined}
						/>
					)
				}
			</Route>
			<Route
				path={[`/v2/goals/:goalID`, `/v2/users/:id/goals/:goalID`, `/users/:id/goals/:goalID`]}
				exact
			>
				{({ match }) =>
					match && (
						<Goal
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={match.params.goalID}
						/>
					)
				}
			</Route>
			<Route
				path={[
					`/v2/goals/:goalID/revisions/:revision`,
					`/v2/users/:id/goals/:goalID/revisions/:revision`,
				]}
				exact
			>
				{({ match }) =>
					match && (
						<GoalRevision
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={match.params.goalID}
							revision={match.params.revision}
						/>
					)
				}
			</Route>
		</Switch>
	);
}
